import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';
export default (function (params) {
  let apiUrl = `/api/inspection_product_configs/details/items`;
  const { exec, data, isRequestSuccessed } = useRequest({
    url: '',
    name: 'GET_SITE_INSPECTION_LIST',
    manual: false,
  });
  useEffect(() => {
    if (params) {
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          apiUrl += '?';
        } else {
          apiUrl += '&';
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        apiUrl += `${key}=${params[key]}`;
      });
      exec(apiUrl);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);
  return [data || [], isRequestSuccessed];
});
